module.exports = "<div class=\"container\">\n  <div class=\"container-body\"><router-outlet></router-outlet></div>\n  <app-footer></app-footer>\n</div>\n"